import { render, staticRenderFns } from "./cu-table.vue?vue&type=template&id=015d4234"
import script from "./cu-table.vue?vue&type=script&lang=js"
export * from "./cu-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports